import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import AppLayout from '../components/layout/AppLayout';
import AgentUpload from '../components/agent/AgentUpload';
import useShipments from '../hooks/useShipments';
import UploadHistory from '../components/agent/UploadHistory';

const ACTIVITY_TYPE_BY_CAT = {
  4: 'freight',
  9: 'freight',
  6: 'business_travel',
  7: 'employee_commute',
};

export default function ShipmentsBulk() {
  const navigate = useNavigate();
  const { shipments, reload } = useShipments();
  const [historyKey, setHistoryKey] = useState(0);
  const [ghgCategory, setGhgCategory] = useState(4);

  return (
    <AppLayout title="Bulk Upload">
      <div className="max-w-5xl mx-auto space-y-5">
        {/* GHG category picker — drives the bulk schema */}
        <div className="p-4 bg-white border border-gray-200 rounded-xl shadow-sm">
          <div className="flex flex-col md:flex-row md:items-center gap-3">
            <Label className="text-sm font-medium text-gray-700 md:min-w-[220px]">
              GHG Protocol Category
            </Label>
            <Select value={String(ghgCategory)} onValueChange={(v) => setGhgCategory(Number(v))}>
              <SelectTrigger className="md:max-w-md bg-white border-gray-300 rounded-xl">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-white rounded-xl">
                <SelectItem value="4">Cat 4 — Upstream transport</SelectItem>
                <SelectItem value="9">Cat 9 — Downstream transport</SelectItem>
                <SelectItem value="6">Cat 6 — Business travel</SelectItem>
                <SelectItem value="7">Cat 7 — Employee commuting</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <p className="text-xs text-gray-500 mt-2">
            Upload a CSV/XLSX. The wizard will auto-detect columns, let you review the mapping,
            then process and save.
          </p>
        </div>

        <AgentUpload
          onShipmentsSaved={async () => { await reload(); setHistoryKey((k) => k + 1); }}
          activityType={ACTIVITY_TYPE_BY_CAT[ghgCategory] || 'freight'}
          onGoToDashboard={async () => {
            await reload();
            navigate('/dashboard');
          }}
        />

        {/* Past uploads: open one to see only that file's entries */}
        <UploadHistory shipments={shipments} refreshKey={historyKey} />
      </div>
    </AppLayout>
  );
}
